module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5b91a86ddfdef5d57cd5b190eab2f37e.gif";